package one.healthium.onboarding.domain.configs

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import one.healthium.domain.common.TextStyle
import one.healthium.onboarding.domain.models.PlanSection

@Serializable
@SerialName("final_personal_plan")
data class FinalPersonalPlanScreenConfig(
    @SerialName("title") val title: String? = null,
    @SerialName("title_style") val titleStyle: TextStyle? = null,
    @SerialName("subtitle") val subtitle: String? = null,
    @SerialName("image") val image: String? = null,
    @SerialName("cta_title") val ctaTitle: String? = null,
    @SerialName("sections") val sections: List<PlanSection> = emptyList(),
) : ScreenConfig